export default __webpack_public_path__ + "static/img/vogue_scene_animated_0244.f406190.webp";